import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CommonClient } from "../../parentApi";

const client = new CommonClient(app_uri, axiosClient());

export default client;
